import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura-compat'
import { Form } from '@primevue/forms'
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionPanel,
  AutoComplete,
  Avatar,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Chip,
  ColorPicker,
  Column,
  DataTable,
  DataView,
  DatePicker,
  Dialog,
  FileUpload,
  FloatLabel,
  Galleria,
  Image,
  Inplace,
  InputGroup,
  InputGroupAddon,
  InputNumber,
  InputText,
  Menubar,
  Message,
  Paginator,
  Panel,
  PanelMenu,
  Password,
  Popover,
  ProgressSpinner,
  RadioButton,
  Select,
  SelectButton,
  Skeleton,
  SplitButton,
  Splitter,
  SplitterPanel,
  Step,
  StepItem,
  StepList,
  StepPanel,
  StepPanels,
  Stepper,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tag,
  Textarea,
  Timeline,
  Toast,
  ToggleSwitch,
  Tooltip,
  Tree,
  TreeSelect,
} from 'primevue'
import PrimeVue from 'primevue/config'
import Editor from 'primevue/editor'
import Menu from 'primevue/menu'
import ScrollPanel from 'primevue/scrollpanel'

export default ({ app }) => {
  const Preset = definePreset(Aura, {
    semantic: {
      primary: {
        50: '#f7f4fe',
        100: '#f0eafe',
        200: '#e2d7fb',
        300: '#cfbdf7',
        400: '#b89af2',
        500: '#9F78EC',
        600: '#8559dd',
        700: '#6e42c4',
        800: '#5a369f',
        900: '#492e7f',
        950: '#2d1a52',
      },
      colorScheme: {
        light: {
          surface: {
            0: '#f4f1ef',
            100: '#f9f8f7',
            200: '#bebebe',
            300: '#bebebe',
          },
        },
      },
    },
    components: {
      skeleton: {
        colorScheme: {
          light: {
            root: {
              background: '{surface.100}',
              animationBackground: '{surface.0}',
            },
          },
        },
      },
    },
  })

  app.use(PrimeVue, {
    theme: {
      preset: Preset,
      options: {
        darkModeSelector: false,
      },
    },
    license:
      'eyJpZCI6ImExMWViYTM4LWE1MDMtNDMwZC1iZWE4LWIwNGJlYmExNGY2NCIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODYzNzAyNjgsImV4cCI6MTgxNzkwNjI2OH0.Atl8QFLxpaI2u9LTvojhfxbHz3tbaXh8sEBdKovDnKa90Z-KDKctRz_J-RE9lsecHVp_3pEcqyGCC6lF226eAw',
  })

  app.directive('tooltip', Tooltip)

  app.component('Button', Button)
  app.component('SplitButton', SplitButton)
  app.component('DatePicker', DatePicker)
  app.component('Editor', Editor)
  app.component('ProgressSpinner', ProgressSpinner)
  app.component('Breadcrumb', Breadcrumb)
  app.component('Menubar', Menubar)
  app.component('Form', Form)
  app.component('InputText', InputText)
  app.component('InputNumber', InputNumber)
  app.component('Avatar', Avatar)
  app.component('Dialog', Dialog)
  app.component('Stepper', Stepper)
  app.component('StepItem', StepItem)
  app.component('Step', Step)
  app.component('StepPanel', StepPanel)
  app.component('Card', Card)
  app.component('Password', Password)
  app.component('Toast', Toast)
  app.component('Message', Message)
  app.component('Image', Image)
  app.component('DataView', DataView)
  app.component('Splitter', Splitter)
  app.component('SplitterPanel', SplitterPanel)
  app.component('Inplace', Inplace)
  app.component('Menu', Menu)
  app.component('FileUpload', FileUpload)
  app.component('TreeSelect', TreeSelect)
  app.component('Tree', Tree)
  app.component('DataTable', DataTable)
  app.component('Column', Column)
  app.component('Select', Select)
  app.component('ColorPicker', ColorPicker)
  app.component('FloatLabel', FloatLabel)
  app.component('Message', Message)
  app.component('PanelMenu', PanelMenu)
  app.component('Accordion', Accordion)
  app.component('AccordionPanel', AccordionPanel)
  app.component('AccordionHeader', AccordionHeader)
  app.component('AccordionContent', AccordionContent)
  app.component('Badge', Badge)
  app.component('Timeline', Timeline)
  app.component('Galleria', Galleria)
  app.component('Popover', Popover)
  app.component('InputGroup', InputGroup)
  app.component('InputGroupAddon', InputGroupAddon)
  app.component('Tab', Tab)
  app.component('Tabs', Tabs)
  app.component('TabList', TabList)
  app.component('TabPanel', TabPanel)
  app.component('TabPanels', TabPanels)
  app.component('Checkbox', Checkbox)
  app.component('Paginator', Paginator)
  app.component('Textarea', Textarea)
  app.component('Panel', Panel)
  app.component('RadioButton', RadioButton)
  app.component('SelectButton', SelectButton)
  app.component('AutoComplete', AutoComplete)
  app.component('ScrollPanel', ScrollPanel)
  app.component('ToggleSwitch', ToggleSwitch)
  app.component('Password', Password)
  app.component('StepList', StepList)
  app.component('StepPanels', StepPanels)
  app.component('Chip', Chip)
  app.component('Tag', Tag)
  app.component('Skeleton', Skeleton)
}
